import { render, staticRenderFns } from "./FlaggingTool.vue?vue&type=template&id=9c9c079e&scoped=true"
import script from "./FlaggingTool.vue?vue&type=script&lang=js"
export * from "./FlaggingTool.vue?vue&type=script&lang=js"
import style0 from "./FlaggingTool.vue?vue&type=style&index=0&id=9c9c079e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9c079e",
  null
  
)

export default component.exports